module.exports = __webpack_public_path__ + "media/bootstrap-icons/backspace-fill-430b44bf.svg";